(function () {
  function initGallery(root) {
    var stage = root.querySelector('[data-footwear-stage]');
    root.querySelectorAll('.footwear-thumbs button').forEach(function (button) {
      button.addEventListener('click', function () {
        if (stage && button.dataset.footwearImage) stage.src = button.dataset.footwearImage;
        root.querySelectorAll('.footwear-thumbs button').forEach(function (item) { item.setAttribute('aria-pressed', item === button ? 'true' : 'false'); });
      });
    });
  }

  function initWaitlist(root) {
    var form = root.querySelector('[data-waitlist-form]');
    if (!form) return;
    form.addEventListener('submit', function () {
      var tags = form.querySelector('[data-waitlist-tags]');
      var size = form.querySelector('[data-waitlist-size]');
      var consent = form.querySelector('[data-waitlist-consent]');
      if (!tags) return;
      var value = 'ghost-pulse-waitlist';
      if (size && size.value) value += ',size-' + size.value.replace(/\s+/g, '-').toLowerCase();
      if (consent && consent.checked) value += ',marketing-consent';
      tags.value = value;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.eight-rox-footwear').forEach(function (root) { initGallery(root); initWaitlist(root); });
  });
})();
